import React, { Component } from 'react';
import { graphql, compose } from 'react-apollo';
import { getCategoriesByTypes, getCategoryByGenre, getNations, getLanguages } from '../../graphqlDic';
import { connect } from 'react-redux';
import { TYPE_MOVIES, GENRE_FORM, GENRE_KIND } from '../../constants/TypesAndGenreCategory';
import MoviesPageComponent from '../../components/MoviePageComponent/MoviesPageComponent';
import FilterOptionsComponent from '../../components/MoviePageComponent/FilterOptionsComponent';
import SliderList from './../../containers/SliderList';

class MoviesPageContent extends Component {

    ShowMoviePageContent = (dataCategories) => {
        let result = [];

        for (let indexTypes in dataCategories) {
            result.push(
                <MoviesPageComponent
                    key={ indexTypes }
                    dataCategories={ dataCategories[indexTypes] }
                />
            );
        }
        return result
    }

    render() {

        let {
            getCategoriesByTypes,
            getCategoryByGenreForm,
            getCategoryByGenreKind,
            getLanguages,
            getNations
        } = this.props;

        if (
            getCategoriesByTypes.loading ||
            getCategoryByGenreForm.loading ||
            getCategoryByGenreKind.loading ||
            getLanguages.loading           ||
            getNations.loading
        ) return <div className="container"><p className="text-center">Loading...</p></div>;

        if (
            getCategoriesByTypes.error ||
            getCategoryByGenreForm.error ||
            getCategoryByGenreKind.error ||
            getLanguages.error           ||
            getNations.error
        ) return (
            `Error! ${getCategoriesByTypes.error.message} -
                    ${getCategoryByGenreForm.error.message} -
                    ${getCategoryByGenreKind.error.message} -
                    ${getLanguages.error.message}           -
                    ${getNations.error.message}             -
            `
        );

        let dataCategories = getCategoriesByTypes.getCategoriesByTypes;
        let listCategoriesForm = getCategoryByGenreForm.getCategoryByGenre;
        let listCategoriesKind = getCategoryByGenreKind.getCategoryByGenre;
        let languages = getLanguages.getLanguages;
        let nations = getNations.getNations;

        return (
            dataCategories ?
            <div className="block-index">

                <SliderList type={ TYPE_MOVIES } />

                <FilterOptionsComponent
                    categoriesForm={ listCategoriesForm }
                    categoriesKind={ listCategoriesKind }
                    languages={ languages }
                    nations={ nations }
                />

                { this.ShowMoviePageContent(dataCategories) }

            </div>
            : <div className="container"><p className="text-center">Không có nội dung!</p></div>
        );
    }

}

export default compose(
    graphql(getCategoriesByTypes, {
        name: 'getCategoriesByTypes',
        options: (props) =>  ({
            variables: {
                type: TYPE_MOVIES
            }
        })
    }),
    graphql(getCategoryByGenre, {
        name: 'getCategoryByGenreForm',
        options: (props) =>  ({
            variables: {
                genre: GENRE_FORM,
                type: TYPE_MOVIES
            }
        })
    }),
    graphql(getCategoryByGenre, {
        name: 'getCategoryByGenreKind',
        options: (props) =>  ({
            variables: {
                genre: GENRE_KIND,
                type: TYPE_MOVIES
            }
        })
    }),
    graphql(getNations, {
        name: 'getNations'
    }),
    graphql(getLanguages, {
        name: 'getLanguages'
    })
)(connect(
    null,
    null
)(MoviesPageContent));



// WEBPACK FOOTER //
// ./src/containers/MoviesPage/MoviesPageContent.js